var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "18px",
    viewBox: "0 0 13 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow up narrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CreateNewTaskDocument",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DefaultView-for-Document",
    transform: "translate(-398.000000, -255.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-ENTRY",
    transform: "translate(375.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Section-background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 375,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", {
    id: "English",
    transform: "translate(0.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.853703, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File-upload"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "App-Icon",
    fill: "#007AFF",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2442497,9.91561439 L15.2442497,21.1394789 C15.2442497,21.8341142 14.6887417,22.4 14,22.4 C13.3112583,22.4 12.7557503,21.8341142 12.7557503,21.1394789 L12.7557503,9.91561439 L10.1874355,12.5564287 C9.70098695,13.0519648 8.90938743,13.0519648 8.42293893,12.5564287 C7.94027036,12.0647432 7.94027036,11.2703761 8.42293893,10.7786906 L13.1177517,5.97165207 C13.2343997,5.85282493 13.371429,5.75993572 13.5213512,5.69674687 C13.671849,5.63317286 13.833959,5.6 14,5.6 C14.166041,5.6 14.328151,5.63317286 14.4783665,5.69662775 C14.628571,5.75993572 14.7656003,5.85282493 14.8822483,5.97165207 L19.5770611,10.7786906 C20.0597296,11.2703761 20.0597296,12.0647432 19.5770611,12.5564287 C19.0906126,13.0519648 18.299013,13.0519648 17.8125645,12.5564287 L15.2442497,9.91561439 Z",
    id: "Arrow-up-narrow",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.806015b25d386d5295cd50344dc563a5.svg";
export { ForwardRef as ReactComponent };